(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));

},{}],2:[function(require,module,exports){
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));

},{}],3:[function(require,module,exports){
/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'desandro-matches-selector/matches-selector'
    ], function( matchesSelector ) {
      return factory( window, matchesSelector );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('desandro-matches-selector')
    );
  } else {
    // browser global
    window.fizzyUIUtils = factory(
      window,
      window.matchesSelector
    );
  }

}( window, function factory( window, matchesSelector ) {

'use strict';

var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }
  // return empty array if undefined or null. #6
  if ( obj === null || obj === undefined ) {
    return [];
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem.parentNode && elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  threshold = threshold || 100;
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    clearTimeout( timeout );

    var args = arguments;
    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));

},{"desandro-matches-selector":1}],4:[function(require,module,exports){
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

( function( window, factory ) {
  /* jshint strict: false */ /* globals define, module */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See https://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );
  // round value for browser zoom. desandro/masonry#928
  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
  getSize.isBoxSizeOuter = isBoxSizeOuter;

  body.removeChild( div );
}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});

},{}],5:[function(require,module,exports){
/*!
 * Masonry v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
        'outlayer/outlayer',
        'get-size/get-size'
      ],
      factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('outlayer'),
      require('get-size')
    );
  } else {
    // browser global
    window.Masonry = factory(
      window.Outlayer,
      window.getSize
    );
  }

}( window, function factory( Outlayer, getSize ) {

'use strict';

// -------------------------- masonryDefinition -------------------------- //

  // create an Outlayer layout class
  var Masonry = Outlayer.create('masonry');
  // isFitWidth -> fitWidth
  Masonry.compatOptions.fitWidth = 'isFitWidth';

  var proto = Masonry.prototype;

  proto._resetLayout = function() {
    this.getSize();
    this._getMeasurement( 'columnWidth', 'outerWidth' );
    this._getMeasurement( 'gutter', 'outerWidth' );
    this.measureColumns();

    // reset column Y
    this.colYs = [];
    for ( var i=0; i < this.cols; i++ ) {
      this.colYs.push( 0 );
    }

    this.maxY = 0;
    this.horizontalColIndex = 0;
  };

  proto.measureColumns = function() {
    this.getContainerWidth();
    // if columnWidth is 0, default to outerWidth of first item
    if ( !this.columnWidth ) {
      var firstItem = this.items[0];
      var firstItemElem = firstItem && firstItem.element;
      // columnWidth fall back to item of first element
      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||
        // if first elem has no width, default to size of container
        this.containerWidth;
    }

    var columnWidth = this.columnWidth += this.gutter;

    // calculate columns
    var containerWidth = this.containerWidth + this.gutter;
    var cols = containerWidth / columnWidth;
    // fix rounding errors, typically with gutters
    var excess = columnWidth - containerWidth % columnWidth;
    // if overshoot is less than a pixel, round up, otherwise floor it
    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
    cols = Math[ mathMethod ]( cols );
    this.cols = Math.max( cols, 1 );
  };

  proto.getContainerWidth = function() {
    // container is parent if fit width
    var isFitWidth = this._getOption('fitWidth');
    var container = isFitWidth ? this.element.parentNode : this.element;
    // check that this.size and size are there
    // IE8 triggers resize on body size change, so they might not be
    var size = getSize( container );
    this.containerWidth = size && size.innerWidth;
  };

  proto._getItemLayoutPosition = function( item ) {
    item.getSize();
    // how many columns does this brick span
    var remainder = item.size.outerWidth % this.columnWidth;
    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
    // round if off by 1 pixel, otherwise use ceil
    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );
    colSpan = Math.min( colSpan, this.cols );
    // use horizontal or top column position
    var colPosMethod = this.options.horizontalOrder ?
      '_getHorizontalColPosition' : '_getTopColPosition';
    var colPosition = this[ colPosMethod ]( colSpan, item );
    // position the brick
    var position = {
      x: this.columnWidth * colPosition.col,
      y: colPosition.y
    };
    // apply setHeight to necessary columns
    var setHeight = colPosition.y + item.size.outerHeight;
    var setMax = colSpan + colPosition.col;
    for ( var i = colPosition.col; i < setMax; i++ ) {
      this.colYs[i] = setHeight;
    }

    return position;
  };

  proto._getTopColPosition = function( colSpan ) {
    var colGroup = this._getTopColGroup( colSpan );
    // get the minimum Y value from the columns
    var minimumY = Math.min.apply( Math, colGroup );

    return {
      col: colGroup.indexOf( minimumY ),
      y: minimumY,
    };
  };

  /**
   * @param {Number} colSpan - number of columns the element spans
   * @returns {Array} colGroup
   */
  proto._getTopColGroup = function( colSpan ) {
    if ( colSpan < 2 ) {
      // if brick spans only one column, use all the column Ys
      return this.colYs;
    }

    var colGroup = [];
    // how many different places could this brick fit horizontally
    var groupCount = this.cols + 1 - colSpan;
    // for each group potential horizontal position
    for ( var i = 0; i < groupCount; i++ ) {
      colGroup[i] = this._getColGroupY( i, colSpan );
    }
    return colGroup;
  };

  proto._getColGroupY = function( col, colSpan ) {
    if ( colSpan < 2 ) {
      return this.colYs[ col ];
    }
    // make an array of colY values for that one group
    var groupColYs = this.colYs.slice( col, col + colSpan );
    // and get the max value of the array
    return Math.max.apply( Math, groupColYs );
  };

  // get column position based on horizontal index. #873
  proto._getHorizontalColPosition = function( colSpan, item ) {
    var col = this.horizontalColIndex % this.cols;
    var isOver = colSpan > 1 && col + colSpan > this.cols;
    // shift to next row if item can't fit on current row
    col = isOver ? 0 : col;
    // don't let zero-size items take up space
    var hasSize = item.size.outerWidth && item.size.outerHeight;
    this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;

    return {
      col: col,
      y: this._getColGroupY( col, colSpan ),
    };
  };

  proto._manageStamp = function( stamp ) {
    var stampSize = getSize( stamp );
    var offset = this._getElementOffset( stamp );
    // get the columns that this stamp affects
    var isOriginLeft = this._getOption('originLeft');
    var firstX = isOriginLeft ? offset.left : offset.right;
    var lastX = firstX + stampSize.outerWidth;
    var firstCol = Math.floor( firstX / this.columnWidth );
    firstCol = Math.max( 0, firstCol );
    var lastCol = Math.floor( lastX / this.columnWidth );
    // lastCol should not go over if multiple of columnWidth #425
    lastCol -= lastX % this.columnWidth ? 0 : 1;
    lastCol = Math.min( this.cols - 1, lastCol );
    // set colYs to bottom of the stamp

    var isOriginTop = this._getOption('originTop');
    var stampMaxY = ( isOriginTop ? offset.top : offset.bottom ) +
      stampSize.outerHeight;
    for ( var i = firstCol; i <= lastCol; i++ ) {
      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );
    }
  };

  proto._getContainerSize = function() {
    this.maxY = Math.max.apply( Math, this.colYs );
    var size = {
      height: this.maxY
    };

    if ( this._getOption('fitWidth') ) {
      size.width = this._getContainerFitWidth();
    }

    return size;
  };

  proto._getContainerFitWidth = function() {
    var unusedCols = 0;
    // count unused columns
    var i = this.cols;
    while ( --i ) {
      if ( this.colYs[i] !== 0 ) {
        break;
      }
      unusedCols++;
    }
    // fit container to columns that have been used
    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;
  };

  proto.needsResizeLayout = function() {
    var previousWidth = this.containerWidth;
    this.getContainerWidth();
    return previousWidth != this.containerWidth;
  };

  return Masonry;

}));

},{"get-size":4,"outlayer":7}],6:[function(require,module,exports){
/**
 * Outlayer Item
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( [
        'ev-emitter/ev-emitter',
        'get-size/get-size'
      ],
      factory
    );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(
      require('ev-emitter'),
      require('get-size')
    );
  } else {
    // browser global
    window.Outlayer = {};
    window.Outlayer.Item = factory(
      window.EvEmitter,
      window.getSize
    );
  }

}( window, function factory( EvEmitter, getSize ) {
'use strict';

// ----- helpers ----- //

function isEmptyObj( obj ) {
  for ( var prop in obj ) {
    return false;
  }
  prop = null;
  return true;
}

// -------------------------- CSS3 support -------------------------- //


var docElemStyle = document.documentElement.style;

var transitionProperty = typeof docElemStyle.transition == 'string' ?
  'transition' : 'WebkitTransition';
var transformProperty = typeof docElemStyle.transform == 'string' ?
  'transform' : 'WebkitTransform';

var transitionEndEvent = {
  WebkitTransition: 'webkitTransitionEnd',
  transition: 'transitionend'
}[ transitionProperty ];

// cache all vendor properties that could have vendor prefix
var vendorProperties = {
  transform: transformProperty,
  transition: transitionProperty,
  transitionDuration: transitionProperty + 'Duration',
  transitionProperty: transitionProperty + 'Property',
  transitionDelay: transitionProperty + 'Delay'
};

// -------------------------- Item -------------------------- //

function Item( element, layout ) {
  if ( !element ) {
    return;
  }

  this.element = element;
  // parent layout class, i.e. Masonry, Isotope, or Packery
  this.layout = layout;
  this.position = {
    x: 0,
    y: 0
  };

  this._create();
}

// inherit EvEmitter
var proto = Item.prototype = Object.create( EvEmitter.prototype );
proto.constructor = Item;

proto._create = function() {
  // transition objects
  this._transn = {
    ingProperties: {},
    clean: {},
    onEnd: {}
  };

  this.css({
    position: 'absolute'
  });
};

// trigger specified handler for event type
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

/**
 * apply CSS styles to element
 * @param {Object} style
 */
proto.css = function( style ) {
  var elemStyle = this.element.style;

  for ( var prop in style ) {
    // use vendor property if available
    var supportedProp = vendorProperties[ prop ] || prop;
    elemStyle[ supportedProp ] = style[ prop ];
  }
};

 // measure position, and sets it
proto.getPosition = function() {
  var style = getComputedStyle( this.element );
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');
  var xValue = style[ isOriginLeft ? 'left' : 'right' ];
  var yValue = style[ isOriginTop ? 'top' : 'bottom' ];
  var x = parseFloat( xValue );
  var y = parseFloat( yValue );
  // convert percent to pixels
  var layoutSize = this.layout.size;
  if ( xValue.indexOf('%') != -1 ) {
    x = ( x / 100 ) * layoutSize.width;
  }
  if ( yValue.indexOf('%') != -1 ) {
    y = ( y / 100 ) * layoutSize.height;
  }
  // clean up 'auto' or other non-integer values
  x = isNaN( x ) ? 0 : x;
  y = isNaN( y ) ? 0 : y;
  // remove padding from measurement
  x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
  y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;

  this.position.x = x;
  this.position.y = y;
};

// set settled position, apply padding
proto.layoutPosition = function() {
  var layoutSize = this.layout.size;
  var style = {};
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');

  // x
  var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
  var xProperty = isOriginLeft ? 'left' : 'right';
  var xResetProperty = isOriginLeft ? 'right' : 'left';

  var x = this.position.x + layoutSize[ xPadding ];
  // set in percentage or pixels
  style[ xProperty ] = this.getXValue( x );
  // reset other property
  style[ xResetProperty ] = '';

  // y
  var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
  var yProperty = isOriginTop ? 'top' : 'bottom';
  var yResetProperty = isOriginTop ? 'bottom' : 'top';

  var y = this.position.y + layoutSize[ yPadding ];
  // set in percentage or pixels
  style[ yProperty ] = this.getYValue( y );
  // reset other property
  style[ yResetProperty ] = '';

  this.css( style );
  this.emitEvent( 'layout', [ this ] );
};

proto.getXValue = function( x ) {
  var isHorizontal = this.layout._getOption('horizontal');
  return this.layout.options.percentPosition && !isHorizontal ?
    ( ( x / this.layout.size.width ) * 100 ) + '%' : x + 'px';
};

proto.getYValue = function( y ) {
  var isHorizontal = this.layout._getOption('horizontal');
  return this.layout.options.percentPosition && isHorizontal ?
    ( ( y / this.layout.size.height ) * 100 ) + '%' : y + 'px';
};

proto._transitionTo = function( x, y ) {
  this.getPosition();
  // get current x & y from top/left
  var curX = this.position.x;
  var curY = this.position.y;

  var didNotMove = x == this.position.x && y == this.position.y;

  // save end position
  this.setPosition( x, y );

  // if did not move and not transitioning, just go to layout
  if ( didNotMove && !this.isTransitioning ) {
    this.layoutPosition();
    return;
  }

  var transX = x - curX;
  var transY = y - curY;
  var transitionStyle = {};
  transitionStyle.transform = this.getTranslate( transX, transY );

  this.transition({
    to: transitionStyle,
    onTransitionEnd: {
      transform: this.layoutPosition
    },
    isCleaning: true
  });
};

proto.getTranslate = function( x, y ) {
  // flip cooridinates if origin on right or bottom
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');
  x = isOriginLeft ? x : -x;
  y = isOriginTop ? y : -y;
  return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
};

// non transition + transform support
proto.goTo = function( x, y ) {
  this.setPosition( x, y );
  this.layoutPosition();
};

proto.moveTo = proto._transitionTo;

proto.setPosition = function( x, y ) {
  this.position.x = parseFloat( x );
  this.position.y = parseFloat( y );
};

// ----- transition ----- //

/**
 * @param {Object} style - CSS
 * @param {Function} onTransitionEnd
 */

// non transition, just trigger callback
proto._nonTransition = function( args ) {
  this.css( args.to );
  if ( args.isCleaning ) {
    this._removeStyles( args.to );
  }
  for ( var prop in args.onTransitionEnd ) {
    args.onTransitionEnd[ prop ].call( this );
  }
};

/**
 * proper transition
 * @param {Object} args - arguments
 *   @param {Object} to - style to transition to
 *   @param {Object} from - style to start transition from
 *   @param {Boolean} isCleaning - removes transition styles after transition
 *   @param {Function} onTransitionEnd - callback
 */
proto.transition = function( args ) {
  // redirect to nonTransition if no transition duration
  if ( !parseFloat( this.layout.options.transitionDuration ) ) {
    this._nonTransition( args );
    return;
  }

  var _transition = this._transn;
  // keep track of onTransitionEnd callback by css property
  for ( var prop in args.onTransitionEnd ) {
    _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];
  }
  // keep track of properties that are transitioning
  for ( prop in args.to ) {
    _transition.ingProperties[ prop ] = true;
    // keep track of properties to clean up when transition is done
    if ( args.isCleaning ) {
      _transition.clean[ prop ] = true;
    }
  }

  // set from styles
  if ( args.from ) {
    this.css( args.from );
    // force redraw. http://blog.alexmaccaw.com/css-transitions
    var h = this.element.offsetHeight;
    // hack for JSHint to hush about unused var
    h = null;
  }
  // enable transition
  this.enableTransition( args.to );
  // set styles that are transitioning
  this.css( args.to );

  this.isTransitioning = true;

};

// dash before all cap letters, including first for
// WebkitTransform => -webkit-transform
function toDashedAll( str ) {
  return str.replace( /([A-Z])/g, function( $1 ) {
    return '-' + $1.toLowerCase();
  });
}

var transitionProps = 'opacity,' + toDashedAll( transformProperty );

proto.enableTransition = function(/* style */) {
  // HACK changing transitionProperty during a transition
  // will cause transition to jump
  if ( this.isTransitioning ) {
    return;
  }

  // make `transition: foo, bar, baz` from style object
  // HACK un-comment this when enableTransition can work
  // while a transition is happening
  // var transitionValues = [];
  // for ( var prop in style ) {
  //   // dash-ify camelCased properties like WebkitTransition
  //   prop = vendorProperties[ prop ] || prop;
  //   transitionValues.push( toDashedAll( prop ) );
  // }
  // munge number to millisecond, to match stagger
  var duration = this.layout.options.transitionDuration;
  duration = typeof duration == 'number' ? duration + 'ms' : duration;
  // enable transition styles
  this.css({
    transitionProperty: transitionProps,
    transitionDuration: duration,
    transitionDelay: this.staggerDelay || 0
  });
  // listen for transition end event
  this.element.addEventListener( transitionEndEvent, this, false );
};

// ----- events ----- //

proto.onwebkitTransitionEnd = function( event ) {
  this.ontransitionend( event );
};

proto.onotransitionend = function( event ) {
  this.ontransitionend( event );
};

// properties that I munge to make my life easier
var dashedVendorProperties = {
  '-webkit-transform': 'transform'
};

proto.ontransitionend = function( event ) {
  // disregard bubbled events from children
  if ( event.target !== this.element ) {
    return;
  }
  var _transition = this._transn;
  // get property name of transitioned property, convert to prefix-free
  var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;

  // remove property that has completed transitioning
  delete _transition.ingProperties[ propertyName ];
  // check if any properties are still transitioning
  if ( isEmptyObj( _transition.ingProperties ) ) {
    // all properties have completed transitioning
    this.disableTransition();
  }
  // clean style
  if ( propertyName in _transition.clean ) {
    // clean up style
    this.element.style[ event.propertyName ] = '';
    delete _transition.clean[ propertyName ];
  }
  // trigger onTransitionEnd callback
  if ( propertyName in _transition.onEnd ) {
    var onTransitionEnd = _transition.onEnd[ propertyName ];
    onTransitionEnd.call( this );
    delete _transition.onEnd[ propertyName ];
  }

  this.emitEvent( 'transitionEnd', [ this ] );
};

proto.disableTransition = function() {
  this.removeTransitionStyles();
  this.element.removeEventListener( transitionEndEvent, this, false );
  this.isTransitioning = false;
};

/**
 * removes style property from element
 * @param {Object} style
**/
proto._removeStyles = function( style ) {
  // clean up transition styles
  var cleanStyle = {};
  for ( var prop in style ) {
    cleanStyle[ prop ] = '';
  }
  this.css( cleanStyle );
};

var cleanTransitionStyle = {
  transitionProperty: '',
  transitionDuration: '',
  transitionDelay: ''
};

proto.removeTransitionStyles = function() {
  // remove transition
  this.css( cleanTransitionStyle );
};

// ----- stagger ----- //

proto.stagger = function( delay ) {
  delay = isNaN( delay ) ? 0 : delay;
  this.staggerDelay = delay + 'ms';
};

// ----- show/hide/remove ----- //

// remove element from DOM
proto.removeElem = function() {
  this.element.parentNode.removeChild( this.element );
  // remove display: none
  this.css({ display: '' });
  this.emitEvent( 'remove', [ this ] );
};

proto.remove = function() {
  // just remove element if no transition support or no transition
  if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {
    this.removeElem();
    return;
  }

  // start transition
  this.once( 'transitionEnd', function() {
    this.removeElem();
  });
  this.hide();
};

proto.reveal = function() {
  delete this.isHidden;
  // remove display: none
  this.css({ display: '' });

  var options = this.layout.options;

  var onTransitionEnd = {};
  var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
  onTransitionEnd[ transitionEndProperty ] = this.onRevealTransitionEnd;

  this.transition({
    from: options.hiddenStyle,
    to: options.visibleStyle,
    isCleaning: true,
    onTransitionEnd: onTransitionEnd
  });
};

proto.onRevealTransitionEnd = function() {
  // check if still visible
  // during transition, item may have been hidden
  if ( !this.isHidden ) {
    this.emitEvent('reveal');
  }
};

/**
 * get style property use for hide/reveal transition end
 * @param {String} styleProperty - hiddenStyle/visibleStyle
 * @returns {String}
 */
proto.getHideRevealTransitionEndProperty = function( styleProperty ) {
  var optionStyle = this.layout.options[ styleProperty ];
  // use opacity
  if ( optionStyle.opacity ) {
    return 'opacity';
  }
  // get first property
  for ( var prop in optionStyle ) {
    return prop;
  }
};

proto.hide = function() {
  // set flag
  this.isHidden = true;
  // remove display: none
  this.css({ display: '' });

  var options = this.layout.options;

  var onTransitionEnd = {};
  var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
  onTransitionEnd[ transitionEndProperty ] = this.onHideTransitionEnd;

  this.transition({
    from: options.visibleStyle,
    to: options.hiddenStyle,
    // keep hidden stuff hidden
    isCleaning: true,
    onTransitionEnd: onTransitionEnd
  });
};

proto.onHideTransitionEnd = function() {
  // check if still hidden
  // during transition, item may have been un-hidden
  if ( this.isHidden ) {
    this.css({ display: 'none' });
    this.emitEvent('hide');
  }
};

proto.destroy = function() {
  this.css({
    position: '',
    left: '',
    right: '',
    top: '',
    bottom: '',
    transition: '',
    transform: ''
  });
};

return Item;

}));

},{"ev-emitter":2,"get-size":4}],7:[function(require,module,exports){
/*!
 * Outlayer v2.1.1
 * the brains and guts of a layout library
 * MIT license
 */

( function( window, factory ) {
  'use strict';
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( [
        'ev-emitter/ev-emitter',
        'get-size/get-size',
        'fizzy-ui-utils/utils',
        './item'
      ],
      function( EvEmitter, getSize, utils, Item ) {
        return factory( window, EvEmitter, getSize, utils, Item);
      }
    );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(
      window,
      require('ev-emitter'),
      require('get-size'),
      require('fizzy-ui-utils'),
      require('./item')
    );
  } else {
    // browser global
    window.Outlayer = factory(
      window,
      window.EvEmitter,
      window.getSize,
      window.fizzyUIUtils,
      window.Outlayer.Item
    );
  }

}( window, function factory( window, EvEmitter, getSize, utils, Item ) {
'use strict';

// ----- vars ----- //

var console = window.console;
var jQuery = window.jQuery;
var noop = function() {};

// -------------------------- Outlayer -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Outlayer intances
var instances = {};


/**
 * @param {Element, String} element
 * @param {Object} options
 * @constructor
 */
function Outlayer( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for ' + this.constructor.namespace +
        ': ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }

  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // add id for Outlayer.getFromElement
  var id = ++GUID;
  this.element.outlayerGUID = id; // expando
  instances[ id ] = this; // associate via id

  // kick it off
  this._create();

  var isInitLayout = this._getOption('initLayout');
  if ( isInitLayout ) {
    this.layout();
  }
}

// settings are for internal use only
Outlayer.namespace = 'outlayer';
Outlayer.Item = Item;

// default options
Outlayer.defaults = {
  containerStyle: {
    position: 'relative'
  },
  initLayout: true,
  originLeft: true,
  originTop: true,
  resize: true,
  resizeContainer: true,
  // item options
  transitionDuration: '0.4s',
  hiddenStyle: {
    opacity: 0,
    transform: 'scale(0.001)'
  },
  visibleStyle: {
    opacity: 1,
    transform: 'scale(1)'
  }
};

var proto = Outlayer.prototype;
// inherit EvEmitter
utils.extend( proto, EvEmitter.prototype );

/**
 * set options
 * @param {Object} opts
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

/**
 * get backwards compatible option value, check old name
 */
proto._getOption = function( option ) {
  var oldOption = this.constructor.compatOptions[ option ];
  return oldOption && this.options[ oldOption ] !== undefined ?
    this.options[ oldOption ] : this.options[ option ];
};

Outlayer.compatOptions = {
  // currentName: oldName
  initLayout: 'isInitLayout',
  horizontal: 'isHorizontal',
  layoutInstant: 'isLayoutInstant',
  originLeft: 'isOriginLeft',
  originTop: 'isOriginTop',
  resize: 'isResizeBound',
  resizeContainer: 'isResizingContainer'
};

proto._create = function() {
  // get items from children
  this.reloadItems();
  // elements that affect layout, but are not laid out
  this.stamps = [];
  this.stamp( this.options.stamp );
  // set container style
  utils.extend( this.element.style, this.options.containerStyle );

  // bind resize method
  var canBindResize = this._getOption('resize');
  if ( canBindResize ) {
    this.bindResize();
  }
};

// goes through all children again and gets bricks in proper order
proto.reloadItems = function() {
  // collection of item elements
  this.items = this._itemize( this.element.children );
};


/**
 * turn elements into Outlayer.Items to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - collection of new Outlayer Items
 */
proto._itemize = function( elems ) {

  var itemElems = this._filterFindItemElements( elems );
  var Item = this.constructor.Item;

  // create new Outlayer Items for collection
  var items = [];
  for ( var i=0; i < itemElems.length; i++ ) {
    var elem = itemElems[i];
    var item = new Item( elem, this );
    items.push( item );
  }

  return items;
};

/**
 * get item elements to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - item elements
 */
proto._filterFindItemElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.itemSelector );
};

/**
 * getter method for getting item elements
 * @returns {Array} elems - collection of item elements
 */
proto.getItemElements = function() {
  return this.items.map( function( item ) {
    return item.element;
  });
};

// ----- init & layout ----- //

/**
 * lays out all items
 */
proto.layout = function() {
  this._resetLayout();
  this._manageStamps();

  // don't animate first layout
  var layoutInstant = this._getOption('layoutInstant');
  var isInstant = layoutInstant !== undefined ?
    layoutInstant : !this._isLayoutInited;
  this.layoutItems( this.items, isInstant );

  // flag for initalized
  this._isLayoutInited = true;
};

// _init is alias for layout
proto._init = proto.layout;

/**
 * logic before any new layout
 */
proto._resetLayout = function() {
  this.getSize();
};


proto.getSize = function() {
  this.size = getSize( this.element );
};

/**
 * get measurement from option, for columnWidth, rowHeight, gutter
 * if option is String -> get element from selector string, & get size of element
 * if option is Element -> get size of element
 * else use option as a number
 *
 * @param {String} measurement
 * @param {String} size - width or height
 * @private
 */
proto._getMeasurement = function( measurement, size ) {
  var option = this.options[ measurement ];
  var elem;
  if ( !option ) {
    // default to 0
    this[ measurement ] = 0;
  } else {
    // use option as an element
    if ( typeof option == 'string' ) {
      elem = this.element.querySelector( option );
    } else if ( option instanceof HTMLElement ) {
      elem = option;
    }
    // use size of element, if element
    this[ measurement ] = elem ? getSize( elem )[ size ] : option;
  }
};

/**
 * layout a collection of item elements
 * @api public
 */
proto.layoutItems = function( items, isInstant ) {
  items = this._getItemsForLayout( items );

  this._layoutItems( items, isInstant );

  this._postLayout();
};

/**
 * get the items to be laid out
 * you may want to skip over some items
 * @param {Array} items
 * @returns {Array} items
 */
proto._getItemsForLayout = function( items ) {
  return items.filter( function( item ) {
    return !item.isIgnored;
  });
};

/**
 * layout items
 * @param {Array} items
 * @param {Boolean} isInstant
 */
proto._layoutItems = function( items, isInstant ) {
  this._emitCompleteOnItems( 'layout', items );

  if ( !items || !items.length ) {
    // no items, emit event with empty array
    return;
  }

  var queue = [];

  items.forEach( function( item ) {
    // get x/y object from method
    var position = this._getItemLayoutPosition( item );
    // enqueue
    position.item = item;
    position.isInstant = isInstant || item.isLayoutInstant;
    queue.push( position );
  }, this );

  this._processLayoutQueue( queue );
};

/**
 * get item layout position
 * @param {Outlayer.Item} item
 * @returns {Object} x and y position
 */
proto._getItemLayoutPosition = function( /* item */ ) {
  return {
    x: 0,
    y: 0
  };
};

/**
 * iterate over array and position each item
 * Reason being - separating this logic prevents 'layout invalidation'
 * thx @paul_irish
 * @param {Array} queue
 */
proto._processLayoutQueue = function( queue ) {
  this.updateStagger();
  queue.forEach( function( obj, i ) {
    this._positionItem( obj.item, obj.x, obj.y, obj.isInstant, i );
  }, this );
};

// set stagger from option in milliseconds number
proto.updateStagger = function() {
  var stagger = this.options.stagger;
  if ( stagger === null || stagger === undefined ) {
    this.stagger = 0;
    return;
  }
  this.stagger = getMilliseconds( stagger );
  return this.stagger;
};

/**
 * Sets position of item in DOM
 * @param {Outlayer.Item} item
 * @param {Number} x - horizontal position
 * @param {Number} y - vertical position
 * @param {Boolean} isInstant - disables transitions
 */
proto._positionItem = function( item, x, y, isInstant, i ) {
  if ( isInstant ) {
    // if not transition, just set CSS
    item.goTo( x, y );
  } else {
    item.stagger( i * this.stagger );
    item.moveTo( x, y );
  }
};

/**
 * Any logic you want to do after each layout,
 * i.e. size the container
 */
proto._postLayout = function() {
  this.resizeContainer();
};

proto.resizeContainer = function() {
  var isResizingContainer = this._getOption('resizeContainer');
  if ( !isResizingContainer ) {
    return;
  }
  var size = this._getContainerSize();
  if ( size ) {
    this._setContainerMeasure( size.width, true );
    this._setContainerMeasure( size.height, false );
  }
};

/**
 * Sets width or height of container if returned
 * @returns {Object} size
 *   @param {Number} width
 *   @param {Number} height
 */
proto._getContainerSize = noop;

/**
 * @param {Number} measure - size of width or height
 * @param {Boolean} isWidth
 */
proto._setContainerMeasure = function( measure, isWidth ) {
  if ( measure === undefined ) {
    return;
  }

  var elemSize = this.size;
  // add padding and border width if border box
  if ( elemSize.isBorderBox ) {
    measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +
      elemSize.borderLeftWidth + elemSize.borderRightWidth :
      elemSize.paddingBottom + elemSize.paddingTop +
      elemSize.borderTopWidth + elemSize.borderBottomWidth;
  }

  measure = Math.max( measure, 0 );
  this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';
};

/**
 * emit eventComplete on a collection of items events
 * @param {String} eventName
 * @param {Array} items - Outlayer.Items
 */
proto._emitCompleteOnItems = function( eventName, items ) {
  var _this = this;
  function onComplete() {
    _this.dispatchEvent( eventName + 'Complete', null, [ items ] );
  }

  var count = items.length;
  if ( !items || !count ) {
    onComplete();
    return;
  }

  var doneCount = 0;
  function tick() {
    doneCount++;
    if ( doneCount == count ) {
      onComplete();
    }
  }

  // bind callback
  items.forEach( function( item ) {
    item.once( eventName, tick );
  });
};

/**
 * emits events via EvEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  // add original event to arguments
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery ) {
    // set this.$element
    this.$element = this.$element || jQuery( this.element );
    if ( event ) {
      // create jQuery event
      var $event = jQuery.Event( event );
      $event.type = type;
      this.$element.trigger( $event, args );
    } else {
      // just trigger with type if no event available
      this.$element.trigger( type, args );
    }
  }
};

// -------------------------- ignore & stamps -------------------------- //


/**
 * keep item in collection, but do not lay it out
 * ignored items do not get skipped in layout
 * @param {Element} elem
 */
proto.ignore = function( elem ) {
  var item = this.getItem( elem );
  if ( item ) {
    item.isIgnored = true;
  }
};

/**
 * return item to layout collection
 * @param {Element} elem
 */
proto.unignore = function( elem ) {
  var item = this.getItem( elem );
  if ( item ) {
    delete item.isIgnored;
  }
};

/**
 * adds elements to stamps
 * @param {NodeList, Array, Element, or String} elems
 */
proto.stamp = function( elems ) {
  elems = this._find( elems );
  if ( !elems ) {
    return;
  }

  this.stamps = this.stamps.concat( elems );
  // ignore
  elems.forEach( this.ignore, this );
};

/**
 * removes elements to stamps
 * @param {NodeList, Array, or Element} elems
 */
proto.unstamp = function( elems ) {
  elems = this._find( elems );
  if ( !elems ){
    return;
  }

  elems.forEach( function( elem ) {
    // filter out removed stamp elements
    utils.removeFrom( this.stamps, elem );
    this.unignore( elem );
  }, this );
};

/**
 * finds child elements
 * @param {NodeList, Array, Element, or String} elems
 * @returns {Array} elems
 */
proto._find = function( elems ) {
  if ( !elems ) {
    return;
  }
  // if string, use argument as selector string
  if ( typeof elems == 'string' ) {
    elems = this.element.querySelectorAll( elems );
  }
  elems = utils.makeArray( elems );
  return elems;
};

proto._manageStamps = function() {
  if ( !this.stamps || !this.stamps.length ) {
    return;
  }

  this._getBoundingRect();

  this.stamps.forEach( this._manageStamp, this );
};

// update boundingLeft / Top
proto._getBoundingRect = function() {
  // get bounding rect for container element
  var boundingRect = this.element.getBoundingClientRect();
  var size = this.size;
  this._boundingRect = {
    left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
    top: boundingRect.top + size.paddingTop + size.borderTopWidth,
    right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),
    bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )
  };
};

/**
 * @param {Element} stamp
**/
proto._manageStamp = noop;

/**
 * get x/y position of element relative to container element
 * @param {Element} elem
 * @returns {Object} offset - has left, top, right, bottom
 */
proto._getElementOffset = function( elem ) {
  var boundingRect = elem.getBoundingClientRect();
  var thisRect = this._boundingRect;
  var size = getSize( elem );
  var offset = {
    left: boundingRect.left - thisRect.left - size.marginLeft,
    top: boundingRect.top - thisRect.top - size.marginTop,
    right: thisRect.right - boundingRect.right - size.marginRight,
    bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
  };
  return offset;
};

// -------------------------- resize -------------------------- //

// enable event handlers for listeners
// i.e. resize -> onresize
proto.handleEvent = utils.handleEvent;

/**
 * Bind layout to window resizing
 */
proto.bindResize = function() {
  window.addEventListener( 'resize', this );
  this.isResizeBound = true;
};

/**
 * Unbind layout to window resizing
 */
proto.unbindResize = function() {
  window.removeEventListener( 'resize', this );
  this.isResizeBound = false;
};

proto.onresize = function() {
  this.resize();
};

utils.debounceMethod( Outlayer, 'onresize', 100 );

proto.resize = function() {
  // don't trigger if size did not change
  // or if resize was unbound. See #9
  if ( !this.isResizeBound || !this.needsResizeLayout() ) {
    return;
  }

  this.layout();
};

/**
 * check if layout is needed post layout
 * @returns Boolean
 */
proto.needsResizeLayout = function() {
  var size = getSize( this.element );
  // check that this.size and size are there
  // IE8 triggers resize on body size change, so they might not be
  var hasSizes = this.size && size;
  return hasSizes && size.innerWidth !== this.size.innerWidth;
};

// -------------------------- methods -------------------------- //

/**
 * add items to Outlayer instance
 * @param {Array or NodeList or Element} elems
 * @returns {Array} items - Outlayer.Items
**/
proto.addItems = function( elems ) {
  var items = this._itemize( elems );
  // add items to collection
  if ( items.length ) {
    this.items = this.items.concat( items );
  }
  return items;
};

/**
 * Layout newly-appended item elements
 * @param {Array or NodeList or Element} elems
 */
proto.appended = function( elems ) {
  var items = this.addItems( elems );
  if ( !items.length ) {
    return;
  }
  // layout and reveal just the new items
  this.layoutItems( items, true );
  this.reveal( items );
};

/**
 * Layout prepended elements
 * @param {Array or NodeList or Element} elems
 */
proto.prepended = function( elems ) {
  var items = this._itemize( elems );
  if ( !items.length ) {
    return;
  }
  // add items to beginning of collection
  var previousItems = this.items.slice(0);
  this.items = items.concat( previousItems );
  // start new layout
  this._resetLayout();
  this._manageStamps();
  // layout new stuff without transition
  this.layoutItems( items, true );
  this.reveal( items );
  // layout previous items
  this.layoutItems( previousItems );
};

/**
 * reveal a collection of items
 * @param {Array of Outlayer.Items} items
 */
proto.reveal = function( items ) {
  this._emitCompleteOnItems( 'reveal', items );
  if ( !items || !items.length ) {
    return;
  }
  var stagger = this.updateStagger();
  items.forEach( function( item, i ) {
    item.stagger( i * stagger );
    item.reveal();
  });
};

/**
 * hide a collection of items
 * @param {Array of Outlayer.Items} items
 */
proto.hide = function( items ) {
  this._emitCompleteOnItems( 'hide', items );
  if ( !items || !items.length ) {
    return;
  }
  var stagger = this.updateStagger();
  items.forEach( function( item, i ) {
    item.stagger( i * stagger );
    item.hide();
  });
};

/**
 * reveal item elements
 * @param {Array}, {Element}, {NodeList} items
 */
proto.revealItemElements = function( elems ) {
  var items = this.getItems( elems );
  this.reveal( items );
};

/**
 * hide item elements
 * @param {Array}, {Element}, {NodeList} items
 */
proto.hideItemElements = function( elems ) {
  var items = this.getItems( elems );
  this.hide( items );
};

/**
 * get Outlayer.Item, given an Element
 * @param {Element} elem
 * @param {Function} callback
 * @returns {Outlayer.Item} item
 */
proto.getItem = function( elem ) {
  // loop through items to get the one that matches
  for ( var i=0; i < this.items.length; i++ ) {
    var item = this.items[i];
    if ( item.element == elem ) {
      // return item
      return item;
    }
  }
};

/**
 * get collection of Outlayer.Items, given Elements
 * @param {Array} elems
 * @returns {Array} items - Outlayer.Items
 */
proto.getItems = function( elems ) {
  elems = utils.makeArray( elems );
  var items = [];
  elems.forEach( function( elem ) {
    var item = this.getItem( elem );
    if ( item ) {
      items.push( item );
    }
  }, this );

  return items;
};

/**
 * remove element(s) from instance and DOM
 * @param {Array or NodeList or Element} elems
 */
proto.remove = function( elems ) {
  var removeItems = this.getItems( elems );

  this._emitCompleteOnItems( 'remove', removeItems );

  // bail if no items to remove
  if ( !removeItems || !removeItems.length ) {
    return;
  }

  removeItems.forEach( function( item ) {
    item.remove();
    // remove item from collection
    utils.removeFrom( this.items, item );
  }, this );
};

// ----- destroy ----- //

// remove and disable Outlayer instance
proto.destroy = function() {
  // clean up dynamic styles
  var style = this.element.style;
  style.height = '';
  style.position = '';
  style.width = '';
  // destroy items
  this.items.forEach( function( item ) {
    item.destroy();
  });

  this.unbindResize();

  var id = this.element.outlayerGUID;
  delete instances[ id ]; // remove reference to instance by id
  delete this.element.outlayerGUID;
  // remove data for jQuery
  if ( jQuery ) {
    jQuery.removeData( this.element, this.constructor.namespace );
  }

};

// -------------------------- data -------------------------- //

/**
 * get Outlayer instance from element
 * @param {Element} elem
 * @returns {Outlayer}
 */
Outlayer.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.outlayerGUID;
  return id && instances[ id ];
};


// -------------------------- create Outlayer class -------------------------- //

/**
 * create a layout class
 * @param {String} namespace
 */
Outlayer.create = function( namespace, options ) {
  // sub-class Outlayer
  var Layout = subclass( Outlayer );
  // apply new options and compatOptions
  Layout.defaults = utils.extend( {}, Outlayer.defaults );
  utils.extend( Layout.defaults, options );
  Layout.compatOptions = utils.extend( {}, Outlayer.compatOptions  );

  Layout.namespace = namespace;

  Layout.data = Outlayer.data;

  // sub-class Item
  Layout.Item = subclass( Item );

  // -------------------------- declarative -------------------------- //

  utils.htmlInit( Layout, namespace );

  // -------------------------- jQuery bridge -------------------------- //

  // make into jQuery plugin
  if ( jQuery && jQuery.bridget ) {
    jQuery.bridget( namespace, Layout );
  }

  return Layout;
};

function subclass( Parent ) {
  function SubClass() {
    Parent.apply( this, arguments );
  }

  SubClass.prototype = Object.create( Parent.prototype );
  SubClass.prototype.constructor = SubClass;

  return SubClass;
}

// ----- helpers ----- //

// how many milliseconds are in each unit
var msUnits = {
  ms: 1,
  s: 1000
};

// munge time-like parameter into millisecond number
// '0.4s' -> 40
function getMilliseconds( time ) {
  if ( typeof time == 'number' ) {
    return time;
  }
  var matches = time.match( /(^\d*\.?\d*)(\w*)/ );
  var num = matches && matches[1];
  var unit = matches && matches[2];
  if ( !num.length ) {
    return 0;
  }
  num = parseFloat( num );
  var mult = msUnits[ unit ] || 1;
  return num * mult;
}

// ----- fin ----- //

// back in global
Outlayer.Item = Item;

return Outlayer;

}));

},{"./item":6,"ev-emitter":2,"fizzy-ui-utils":3,"get-size":4}],8:[function(require,module,exports){
/*!
 * Salvattore 1.0.9 by @rnmp and @ppold
 * https://github.com/rnmp/salvattore
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.salvattore = factory();
  }
}(this, function() {
/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license */

if (!window.matchMedia) {
    window.matchMedia = function() {
        "use strict";

        // For browsers that support matchMedium api such as IE 9 and webkit
        var styleMedia = (window.styleMedia || window.media);

        // For those that don't support matchMedium
        if (!styleMedia) {
            var style       = document.createElement('style'),
                script      = document.getElementsByTagName('script')[0],
                info        = null;

            style.type  = 'text/css';
            style.id    = 'matchmediajs-test';

            script.parentNode.insertBefore(style, script);

            // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
            info = ('getComputedStyle' in window) && window.getComputedStyle(style, null) || style.currentStyle;

            styleMedia = {
                matchMedium: function(media) {
                    var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';

                    // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
                    if (style.styleSheet) {
                        style.styleSheet.cssText = text;
                    } else {
                        style.textContent = text;
                    }

                    // Test if media query is true or false
                    return info.width === '1px';
                }
            };
        }

        return function(media) {
            return {
                matches: styleMedia.matchMedium(media || 'all'),
                media: media || 'all'
            };
        };
    }();
}

/*! matchMedia() polyfill addListener/removeListener extension. Author & copyright (c) 2012: Scott Jehl. Dual MIT/BSD license */
(function(){
    "use strict";

    // Bail out for browsers that have addListener support
    if (window.matchMedia && window.matchMedia('all').addListener) {
        return false;
    }

    var localMatchMedia = window.matchMedia,
        hasMediaQueries = localMatchMedia('only all').matches,
        isListening     = false,
        timeoutID       = 0,    // setTimeout for debouncing 'handleChange'
        queries         = [],   // Contains each 'mql' and associated 'listeners' if 'addListener' is used
        handleChange    = function(evt) {
            // Debounce
            clearTimeout(timeoutID);

            timeoutID = setTimeout(function() {
                for (var i = 0, il = queries.length; i < il; i++) {
                    var mql         = queries[i].mql,
                        listeners   = queries[i].listeners || [],
                        matches     = localMatchMedia(mql.media).matches;

                    // Update mql.matches value and call listeners
                    // Fire listeners only if transitioning to or from matched state
                    if (matches !== mql.matches) {
                        mql.matches = matches;

                        for (var j = 0, jl = listeners.length; j < jl; j++) {
                            listeners[j].call(window, mql);
                        }
                    }
                }
            }, 30);
        };

    window.matchMedia = function(media) {
        var mql         = localMatchMedia(media),
            listeners   = [],
            index       = 0;

        mql.addListener = function(listener) {
            // Changes would not occur to css media type so return now (Affects IE <= 8)
            if (!hasMediaQueries) {
                return;
            }

            // Set up 'resize' listener for browsers that support CSS3 media queries (Not for IE <= 8)
            // There should only ever be 1 resize listener running for performance
            if (!isListening) {
                isListening = true;
                window.addEventListener('resize', handleChange, true);
            }

            // Push object only if it has not been pushed already
            if (index === 0) {
                index = queries.push({
                    mql         : mql,
                    listeners   : listeners
                });
            }

            listeners.push(listener);
        };

        mql.removeListener = function(listener) {
            for (var i = 0, il = listeners.length; i < il; i++){
                if (listeners[i] === listener){
                    listeners.splice(i, 1);
                }
            }
        };

        return mql;
    };
}());

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function() {
    "use strict";

    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] ||
            window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());

// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent

if (typeof window.CustomEvent !== "function") {
  (function() {
    "use strict";
    function CustomEvent(event, params) {
      params = params || { bubbles: false, cancelable: false, detail: undefined };
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
     }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
  })();
}

/* jshint laxcomma: true */
var salvattore = (function (global, document, undefined) {
"use strict";

var self = {},
    grids = [],
    mediaRules = [],
    mediaQueries = [],
    add_to_dataset = function(element, key, value) {
      // uses dataset function or a fallback for <ie10
      if (element.dataset) {
        element.dataset[key] = value;
      } else {
        element.setAttribute("data-" + key, value);
      }
      return;
    };

self.obtainGridSettings = function obtainGridSettings(element) {
  // returns the number of columns and the classes a column should have,
  // from computing the style of the ::before pseudo-element of the grid.

  var computedStyle = global.getComputedStyle(element, ":before")
    , content = computedStyle.getPropertyValue("content").slice(1, -1)
    , matchResult = content.match(/^\s*(\d+)(?:\s?\.(.+))?\s*$/)
    , numberOfColumns = 1
    , columnClasses = []
  ;

  if (matchResult) {
    numberOfColumns = matchResult[1];
    columnClasses = matchResult[2];
    columnClasses = columnClasses? columnClasses.split(".") : ["column"];
  } else {
    matchResult = content.match(/^\s*\.(.+)\s+(\d+)\s*$/);
    if (matchResult) {
      columnClasses = matchResult[1];
      numberOfColumns = matchResult[2];
      if (numberOfColumns) {
            numberOfColumns = numberOfColumns.split(".");
      }
    }
  }

  return {
    numberOfColumns: numberOfColumns,
    columnClasses: columnClasses
  };
};


self.addColumns = function addColumns(grid, items) {
  // from the settings obtained, it creates columns with
  // the configured classes and adds to them a list of items.

  var settings = self.obtainGridSettings(grid)
    , numberOfColumns = settings.numberOfColumns
    , columnClasses = settings.columnClasses
    , columnsItems = new Array(+numberOfColumns)
    , columnsFragment = document.createDocumentFragment()
    , i = numberOfColumns
    , selector
  ;

  while (i-- !== 0) {
    selector = "[data-columns] > *:nth-child(" + numberOfColumns + "n-" + i + ")";
    columnsItems.push(items.querySelectorAll(selector));
  }

  columnsItems.forEach(function append_to_grid_fragment(rows) {
    var column = document.createElement("div")
      , rowsFragment = document.createDocumentFragment()
    ;

    column.className = columnClasses.join(" ");

    Array.prototype.forEach.call(rows, function append_to_column(row) {
      rowsFragment.appendChild(row);
    });
    column.appendChild(rowsFragment);
    columnsFragment.appendChild(column);
  });

  grid.appendChild(columnsFragment);
  add_to_dataset(grid, 'columns', numberOfColumns);
};


self.removeColumns = function removeColumns(grid) {
  // removes all the columns from a grid, and returns a list
  // of items sorted by the ordering of columns.

  var range = document.createRange();
  range.selectNodeContents(grid);

  var columns = Array.prototype.filter.call(range.extractContents().childNodes, function filter_elements(node) {
    return node instanceof global.HTMLElement;
  });

  var numberOfColumns = columns.length
    , numberOfRowsInFirstColumn = columns[0].childNodes.length
    , sortedRows = new Array(numberOfRowsInFirstColumn * numberOfColumns)
  ;

  Array.prototype.forEach.call(columns, function iterate_columns(column, columnIndex) {
    Array.prototype.forEach.call(column.children, function iterate_rows(row, rowIndex) {
      sortedRows[rowIndex * numberOfColumns + columnIndex] = row;
    });
  });

  var container = document.createElement("div");
  add_to_dataset(container, 'columns', 0);

  sortedRows.filter(function filter_non_null(child) {
    return !!child;
  }).forEach(function append_row(child) {
    container.appendChild(child);
  });

  return container;
};


self.recreateColumns = function recreateColumns(grid) {
  // removes all the columns from the grid, and adds them again,
  // it is used when the number of columns change.

  global.requestAnimationFrame(function render_after_css_mediaQueryChange() {
    self.addColumns(grid, self.removeColumns(grid));
    var columnsChange = new CustomEvent("columnsChange");
    grid.dispatchEvent(columnsChange);
  });
};


self.mediaQueryChange = function mediaQueryChange(mql) {
  // recreates the columns when a media query matches the current state
  // of the browser.

  if (mql.matches) {
    Array.prototype.forEach.call(grids, self.recreateColumns);
  }
};


self.getCSSRules = function getCSSRules(stylesheet) {
  // returns a list of css rules from a stylesheet

  var cssRules;
  try {
    cssRules = stylesheet.sheet.cssRules || stylesheet.sheet.rules;
  } catch (e) {
    return [];
  }

  return cssRules || [];
};


self.getStylesheets = function getStylesheets() {
  // returns a list of all the styles in the document (that are accessible).

  var inlineStyleBlocks = Array.prototype.slice.call(document.querySelectorAll("style"));
  inlineStyleBlocks.forEach(function(stylesheet, idx) {
    if (stylesheet.type !== 'text/css' && stylesheet.type !== '') {
      inlineStyleBlocks.splice(idx, 1);
    }
  });

  return Array.prototype.concat.call(
    inlineStyleBlocks,
    Array.prototype.slice.call(document.querySelectorAll("link[rel='stylesheet']"))
  );
};


self.mediaRuleHasColumnsSelector = function mediaRuleHasColumnsSelector(rules) {
  // checks if a media query css rule has in its contents a selector that
  // styles the grid.

  var i, rule;

  try {
    i = rules.length;
  }
  catch (e) {
    i = 0;
  }

  while (i--) {
    rule = rules[i];
    if (rule.selectorText && rule.selectorText.match(/\[data-columns\](.*)::?before$/)) {
      return true;
    }
  }

  return false;
};


self.scanMediaQueries = function scanMediaQueries() {
  // scans all the stylesheets for selectors that style grids,
  // if the matchMedia API is supported.

  var newMediaRules = [];

  if (!global.matchMedia) {
    return;
  }

  self.getStylesheets().forEach(function extract_rules(stylesheet) {
    Array.prototype.forEach.call(self.getCSSRules(stylesheet), function filter_by_column_selector(rule) {
      // rule.media throws an 'not implemented error' in ie9 for import rules occasionally
      try {
        if (rule.media && rule.cssRules && self.mediaRuleHasColumnsSelector(rule.cssRules)) {
          newMediaRules.push(rule);
        }
      } catch (e) {}
    });
  });

  // remove matchMedia listeners from the old rules
  var oldRules = mediaRules.filter(function (el) {
      return newMediaRules.indexOf(el) === -1;
  });
  mediaQueries.filter(function (el) {
    return oldRules.indexOf(el.rule) !== -1;
  }).forEach(function (el) {
      el.mql.removeListener(self.mediaQueryChange);
  });
  mediaQueries = mediaQueries.filter(function (el) {
    return oldRules.indexOf(el.rule) === -1;
  });

  // add matchMedia listeners to the new rules
  newMediaRules.filter(function (el) {
    return mediaRules.indexOf(el) == -1;
  }).forEach(function (rule) {
      var mql = global.matchMedia(rule.media.mediaText);
      mql.addListener(self.mediaQueryChange);
      mediaQueries.push({rule: rule, mql:mql});
  });

  // swap mediaRules with the new set
  mediaRules.length = 0;
  mediaRules = newMediaRules;
};


self.rescanMediaQueries = function rescanMediaQueries() {
    self.scanMediaQueries();
    Array.prototype.forEach.call(grids, self.recreateColumns);
};


self.nextElementColumnIndex = function nextElementColumnIndex(grid, fragments) {
  // returns the index of the column where the given element must be added.

  var children = grid.children
    , m = children.length
    , lowestRowCount = 0
    , child
    , currentRowCount
    , i
    , index = 0
  ;
  for (i = 0; i < m; i++) {
    child = children[i];
    currentRowCount = child.children.length + (fragments[i].children || fragments[i].childNodes).length;
  if(lowestRowCount === 0) {
    lowestRowCount = currentRowCount;
  }
    if(currentRowCount < lowestRowCount) {
      index = i;
      lowestRowCount = currentRowCount;
    }
  }

  return index;
};


self.createFragmentsList = function createFragmentsList(quantity) {
  // returns a list of fragments

  var fragments = new Array(quantity)
    , i = 0
  ;

  while (i !== quantity) {
    fragments[i] = document.createDocumentFragment();
    i++;
  }

  return fragments;
};


self.appendElements = function appendElements(grid, elements) {
  // adds a list of elements to the end of a grid

  var columns = grid.children
    , numberOfColumns = columns.length
    , fragments = self.createFragmentsList(numberOfColumns)
  ;

  Array.prototype.forEach.call(elements, function append_to_next_fragment(element) {
    var columnIndex = self.nextElementColumnIndex(grid, fragments);
    fragments[columnIndex].appendChild(element);
  });

  Array.prototype.forEach.call(columns, function insert_column(column, index) {
    column.appendChild(fragments[index]);
  });
};


self.prependElements = function prependElements(grid, elements) {
  // adds a list of elements to the start of a grid

  var columns = grid.children
    , numberOfColumns = columns.length
    , fragments = self.createFragmentsList(numberOfColumns)
    , columnIndex = numberOfColumns - 1
  ;

  elements.forEach(function append_to_next_fragment(element) {
    var fragment = fragments[columnIndex];
    fragment.insertBefore(element, fragment.firstChild);
    if (columnIndex === 0) {
      columnIndex = numberOfColumns - 1;
    } else {
      columnIndex--;
    }
  });

  Array.prototype.forEach.call(columns, function insert_column(column, index) {
    column.insertBefore(fragments[index], column.firstChild);
  });

  // populates a fragment with n columns till the right
  var fragment = document.createDocumentFragment()
    , numberOfColumnsToExtract = elements.length % numberOfColumns
  ;

  while (numberOfColumnsToExtract-- !== 0) {
    fragment.appendChild(grid.lastChild);
  }

  // adds the fragment to the left
  grid.insertBefore(fragment, grid.firstChild);
};


self.registerGrid = function registerGrid (grid) {
  if (global.getComputedStyle(grid).display === "none") {
    return;
  }

  // retrieve the list of items from the grid itself
  var range = document.createRange();
  range.selectNodeContents(grid);

  var items = document.createElement("div");
  items.appendChild(range.extractContents());


  add_to_dataset(items, 'columns', 0);
  self.addColumns(grid, items);
  grids.push(grid);
};


self.init = function init() {
  // adds required CSS rule to hide 'content' based
  // configuration.

  var css = document.createElement("style");
  css.innerHTML = "[data-columns]::before{display:block;visibility:hidden;position:absolute;font-size:1px;}";
  document.head.appendChild(css);

  // scans all the grids in the document and generates
  // columns from their configuration.

  var gridElements = document.querySelectorAll("[data-columns]");
  Array.prototype.forEach.call(gridElements, self.registerGrid);
  self.scanMediaQueries();
};

self.init();

return {
  appendElements: self.appendElements,
  prependElements: self.prependElements,
  registerGrid: self.registerGrid,
  recreateColumns: self.recreateColumns,
  rescanMediaQueries: self.rescanMediaQueries,
  init: self.init,

  // maintains backwards compatibility with underscore style method names
  append_elements: self.appendElements,
  prepend_elements: self.prependElements,
  register_grid: self.registerGrid,
  recreate_columns: self.recreateColumns,
  rescan_media_queries: self.rescanMediaQueries
};

})(window, window.document);

return salvattore;
}));

},{}],9:[function(require,module,exports){
'use strict'

function init() {
	$('.employees').on('click', '.employee', function() {
		if ($(this).hasClass('employee--active')) {
			cleanup();
		} else {
			cleanup();
			activate($(this));
		}

	});
	$(window).resize(function() {
		cleanup();
	});
	function cleanup() {
		$('.employee').removeClass('employee--active');
		$('.employeeRow__detail').remove();
	}
	function activate(element) {
		insertDetail(element);
		element.addClass('employee--active');
		element.find('.employee__leftColumn, .employee__bio').clone().prependTo('.employeeRow__detail');
		$('.employeeRow__detail--close').on('click', function() {
			cleanup();
		});
	}
	function insertDetail(element) {
		var detailRow = '<div class="employeeRow__detail"><a class="employeeRow__detail--close">close</a></div>';
		var result = element.nextAll('.employee')
		.filter(function() {
			var elOffset = element.offset();
			var thisOffset = $(this).offset();
			return thisOffset.top > elOffset.top;
		}).first();
		if (result.length) {
			return result.before(detailRow);
		} else {
			return $(element).parent().find($('.employee:last-of-type')).after(detailRow);
		}
	}
}


var EmployeeBox = {
	init: init
};

module.exports = EmployeeBox;
},{}],10:[function(require,module,exports){
'use strict'

//var Masonry	= require('./Masonry.js');

function init() {
	$(document).ready(function() {
		function openItem() {
			$('.galleryItem--expandable .image').on('click.expandable', function(event) {
				event.stopPropagation();
				if (event.target.className != 'lightboxTrigger') {
					$(this).parents('.galleryItem--expandable').toggleClass('galleryItem--expanded');
//					Masonry.layout();
				}
			});
			$('.galleryItem--expandable .media__contentInner').on('click.closeItem', function(e) {
				e.stopPropagation();
				$(this).parents('.galleryItem--expandable').removeClass('galleryItem--expanded');
//				Masonry.layout();
			});
		}
		function lightbox() {
			$('.lightboxTrigger').magnificPopup({
				type: 'image',
				image: {
					titleSrc: 'title',
					markup: [
				         // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
						'<div class="mfp-figure">',
							'<div class="mfp-close"></div>',
							'<div class="mfp-img"></div>',
							'<div class="mfp-bottom-bar">',
								'<div class="mfp-title"></div>',
								'<div class="mfp-counter"></div>',
								'<a title="Previous (Left arrow key)" type="button" class="mfp-arrow mfp-arrow-left mfp-prevent-close"></a>',
								'<a title="Next (Right arrow key)" type="button" class="mfp-arrow mfp-arrow-right mfp-prevent-close"></a>',
							'</div>',
						'</div>'
		            ].join(''), 
					verticalFit: true // Fits image in area vertically
				},
				gallery:{
					enabled:true,
					preload: [0,2], // read about this option in next Lazy-loading section
					tCounter: ''
				},
				callbacks: {
					beforeOpen: function(){
						this.wH = $('.mfp-container').height() - $('.mfp-bottom-bar').outerHeight() - 40;
					},
					open: function() {
						var magnificPopup = $.magnificPopup.instance;
						$('.mfp-arrow-left').on('click', function() {
							magnificPopup.prev();
						});
						$('.mfp-arrow-right').on('click', function() {
							magnificPopup.next();
						});
					}
				},
				mainClass: 'mfp-with-zoom', // this class is for CSS animation below
				overflowY: 'hidden',
				zoom: {
					enabled: false, // By default it's false, so don't forget to enable it
					
					duration: 300, // duration of the effect, in milliseconds
					easing: 'ease-in-out', // CSS transition easing function
					
					// The "opener" function should return the element from which popup will be zoomed in
					// and to which popup will be scaled down
					// By defailt it looks for an image tag:
					opener: function(openerElement) {
						// openerElement is the element on which popup was initialized, in this case its <a> tag
						// you don't need to add "opener" option if this code matches your needs, it's defailt one.
						return openerElement.is('img') ? openerElement : openerElement.find('img');
					}
				}
				,removalDelay: 300
			});
		}
		
		lightbox();
		openItem();
	});
}

var GalleryBox = {
	init: init
};

module.exports = GalleryBox;
},{}],11:[function(require,module,exports){
'use strict'

function init() {
	$(document).ready(function() {
		if ($('.loadingScreen').length > 0) {
			window.setTimeout(function() {
				$('.loadingScreen').addClass('loadingScreen--loaded');
			}, 500);
			document.cookie = 'loadingScreenDisplayed=true; expires=Fri, 31 Dec 9999 23:59:59 GMT';
		}
	});
}

var LoadingScreen = {
	init: init
};

module.exports = LoadingScreen;
},{}],12:[function(require,module,exports){
'use strict';

var $ = window.jQuery;

window.initMap = function() {
	var mapElement = $('.js-location-map-wrapper');

	if (mapElement.length) {
		var mapStyles = [
				{
					"featureType": "administrative",
					"elementType": "all",
					"stylers": [
								{
								"hue": "#0060ff"
								},
								{
								"lightness": -100
								},
								{
								"visibility": "off"
								},
								{
								"saturation": "-77"
								}
								]
					},
					{
					"featureType": "administrative",
					"elementType": "labels.text.fill",
					"stylers": [
								{
								"visibility": "on"
								},
								{
								"color": "#848ea4"
								}
								]
					},
					{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
								{
								"color": "#dbe7ed"
								}
								]
					},
					{
					"featureType": "landscape",
					"elementType": "labels",
					"stylers": [
								{
								"hue": "#0060ff"
								},
								{
								"visibility": "off"
								}
								]
					},
					{
					"featureType": "poi",
					"elementType": "all",
					"stylers": [
								{
								"saturation": "-80"
								},
								{
								"lightness": "19"
								},
								{
								"visibility": "simplified"
								},
								{
								"gamma": "1"
								},
								{
								"color": "#cedbe1"
								}
								]
					},
					{
					"featureType": "poi",
					"elementType": "labels",
					"stylers": [
								{
								"visibility": "off"
								},
								{
								"color": "#cecece"
								}
								]
					},
					{
					"featureType": "road",
					"elementType": "geometry",
					"stylers": [
								{
								"saturation": "-78"
								},
								{
								"lightness": "52"
								},
								{
								"visibility": "on"
								},
								{
								"color": "#ffffff"
								}
								]
					},
					{
					"featureType": "road",
					"elementType": "labels",
					"stylers": [
								{
								"saturation": "-39"
								},
								{
								"lightness": "9"
								},
								{
								"visibility": "simplified"
								},
								{
								"hue": "#00a0ff"
								}
								]
					},
					{
					"featureType": "road.highway",
					"elementType": "geometry",
					"stylers": [
								{
								"saturation": "49"
								},
								{
								"visibility": "simplified"
								}
								]
					},
					{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
								{
								"visibility": "simplified"
								},
								{
								"color": "#ffffff"
								}
								]
					},
					{
					"featureType": "road.highway",
					"elementType": "labels",
					"stylers": [
								{
								"visibility": "simplified"
								},
								{
								"hue": "#00a0ff"
								}
								]
					},
					{
					"featureType": "road.local",
					"elementType": "all",
					"stylers": [
								{
								"saturation": "0"
								},
								{
								"lightness": "0"
								},
								{
								"visibility": "simplified"
								},
								{
								"color": "#ffffff"
								},
								{
								"gamma": "1"
								}
								]
					},
					{
					"featureType": "road.local",
					"elementType": "labels",
					"stylers": [
								{
								"color": "#748088"
								},
								{
								"visibility": "simplified"
								}
								]
					},
					{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
								{
								"visibility": "simplified"
								},
								{
								"lightness": "0"
								},
								{
								"saturation": "0"
								},
								{
								"color": "#ffffff"
								}
								]
					},
					{
					"featureType": "transit",
					"elementType": "labels",
					"stylers": [
								{
								"hue": "#0060ff"
								},
								{
								"lightness": -100
								},
								{
								"visibility": "off"
								}
								]
					},
					{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
								{
								"saturation": "0"
								},
								{
								"lightness": 100
								},
								{
								"visibility": "on"
								},
								{
								"color": "#b2c7d3"
								}
								]
					},
					{
					"featureType": "water",
					"elementType": "labels",
					"stylers": [
								{
								"saturation": -100
								},
								{
								"lightness": -100
								},
								{
								"visibility": "simplified"
								},
								{
								"color": "#748088"
								}
								]
					}

		];

		var element;

		for (var i = 0; i < mapElement.length; i++) {
			element = $(mapElement[i]);

			var addressLine1 = element.data('address-line-1');
			var addressLine2 = element.data('address-line-2');
			var directions   = element.data('directions');
			var locationName = element.data('location-name');
			var lat = element.data('lat');
			var lng = element.data('lng');

			var point = new google.maps.LatLng(lat, lng);

			var mapOptions = {
				zoom: 15,
				center: point,
				mapTypeControl: false,
				panControl: true,
				scaleControl: true,
				streetViewControl: false,
				draggable: true,
				scrollwheel:  true,
				zoomControl: true,
				zoomControlOptions: {
					style: google.maps.ZoomControlStyle.LARGE,
					position: google.maps.ControlPosition.RIGHT_CENTER
				},
				styles: mapStyles
			};

			var map = new google.maps.Map(mapElement.get(i), mapOptions);

			var marker = new google.maps.Marker({
				icon: 'assets/images/design/marker.png',
				position: point,
				map: map,
				title: locationName
			});

			var contentString = '<div class="map-popup"><div class="map-popup__title">'+locationName+'</div> <div>'+addressLine1+'<br/>'+addressLine2+'</div> <a href="'+directions+'" target="_blank">Get Directions</a></div>';

			marker.infowindow = new google.maps.InfoWindow({
				content: contentString
			});

			marker.addListener('click', function() {
				this.infowindow.open(this.map, this);
			});
		}
	}
}

module.exports = window.initMap;
},{}],13:[function(require,module,exports){
'use strict';

var Masonry = require('masonry-layout');

var masonry;

function init() {
	var $grid = $('.grid.useMasonry');
	if ($grid.length === 0)
		return;

	var $window = $(window);

	masonry = new Masonry('.grid.useMasonry', {
		// options
		itemSelector : '.grid__item',
		columnWidth : '.grid__item',
		percentPosition : true,
		transitionDuration : 0
	});

	$window.on('load', layout);
	$window.on('resize', layout);
	$grid.on('click', '.grid__item', layout);
	$(window).on('autoLoadedPages', layout); // We have auto loading of pages so relayout if pages loaded

	layout();
}

function layout() {
	var itemsLoading = masonry.$element.find('.grid__item:not(.masonry-loaded)');
	itemsLoading.addClass('masonry-loading');
	masonry.once('layoutComplete', function() {
		itemsLoading.addClass('masonry-loaded');
		itemsLoading.removeClass('masonry-loading');
	});

	masonry.reloadItems();
	masonry.layout();
}

module.exports = {
	init : init,
	layout : layout
};
},{"masonry-layout":5}],14:[function(require,module,exports){
'use strict'

function init() {

	var slides = $('.mastheadSlide');
	var titles = $('.slide__title');

	function slideLeft() {
		changeSlide(-1, 'slide--right', 'slide--left');
	}

	function slideRight() {
		changeSlide(1, 'slide--left', 'slide--right');
	}
	function changeSlide(direction, classToSlideOff, classToPrepareToBringIn) {
		// Current slide
		var active = $('.slide--active');
		var lastIndex = slides.index(active);

		// Next slide
		var nextIndex = lastIndex + direction;

		if (nextIndex >= slides.length) {
			nextIndex = 0;
		} else if (nextIndex < 0) {
			nextIndex = slides.length - 1;
		}
		var next = slides.eq(nextIndex);

		// We use two frames
		// 1) Prepare next slide
		// 2) Make transition
		// (Can't do on these in the same frame because if we do the prepare won't happen before the change happens.
		//		NOTE: we can't do any work here. If you try to do prepare here and next frame change, in FF it will mess
		//		up if you hit the next button really quick. I assume FF runs the requestAnimationFrame right away with
		// 		the frame we are in if.. i assume... not that far into the frame?)
		window.requestAnimationFrame(function() {
			// Prepare next slide to come in by moving to other side
			next.removeClass('slide--transitioning');
			next.addClass(classToPrepareToBringIn);
			next.removeClass(classToSlideOff);

			// Make transition on next frame
			window.requestAnimationFrame(function() {
				// No longer active and slide off to left
				active.addClass('slide--transitioning');
				active.removeClass('slide--active');
				active.addClass(classToSlideOff);

				// Next slide now active and slide in from right
				next.addClass('slide--transitioning');
				next.removeClass(classToPrepareToBringIn);
				next.addClass('slide--active');

				// Auto progress
				startAutoProgress();

				// Change title
				$('.slide__title--active').removeClass('slide__title--active');
				// DEBUG: console.log('Next Slide: ' + nextIndex + '\nTotal Slides: ' + titles.length);
				titles.eq(nextIndex).addClass('slide__title--active');
			});
		});
	}

	var slideAutoProgressTimeoutID;
	function startAutoProgress() {
		clearTimeout(slideAutoProgressTimeoutID);
		slideAutoProgressTimeoutID = setTimeout(slideRight, 4000);
	}
	if ($('.mastheadSlider').length) {
		var slideRightControl = document.querySelector('.mastheadSlider__arrowRightWrapper');
		var slideLeftControl = document.querySelector('.mastheadSlider__arrowLeftWrapper');

		startAutoProgress();
		slideRightControl.addEventListener('click', slideRight, false);
		slideLeftControl.addEventListener('click', slideLeft, false);
	}
}

var MastheadSlider = {
	init: init
}

module.exports = MastheadSlider;

},{}],15:[function(require,module,exports){
'use strict';

/* ========================================================
 * 		Requires
 ========================================================= */
// Polyfills
require('./polyfills/requestAnimationFrame.js');

// JQuery, and Animation Code
var $ = window.jQuery;

// Lib
require('./lib/a4jAjaxEvents.js');
var Forms = require('./lib/Forms.js');

// Components
var MobileMenu 			= require('./site/MobileMenu.js');
var AddClassOnScroll 	= require('./site/AddClassOnScroll.js');
var LoadingScreen		= require('./components/LoadingScreen.js');
var GalleryBox			= require('./components/GalleryBox.js');
var MastheadSlider  	= require('./components/MastheadSlider.js');
var EmployeeBox 		= require('./components/EmployeeBox.js');
var Map					= require('./components/Map.js');
var Masonry				= require('./components/Masonry.js');
var Salvattore 			= require('salvattore');


/* ========================================================
 * 		Setup
 ========================================================= */
var $win = $(window);
var $body = $(document.body); 

//Pages -------------------------------------------------
var insights = require('./site/pages/insights.js');
insights.load();

/* ========================================================
 * 		Component Setup
 ========================================================= */
MobileMenu.init();
AddClassOnScroll.init();
Masonry.init();

// Forms setup
Forms.init();

LoadingScreen.init();
GalleryBox.init();
MastheadSlider.init();
EmployeeBox.init();

/* relies on query mask set in the master-template.xhtml file */
$('form input[type="tel"]').mask('(000) 000-0000');
$('#contact\\:extension').mask('00000');

},{"./components/EmployeeBox.js":9,"./components/GalleryBox.js":10,"./components/LoadingScreen.js":11,"./components/Map.js":12,"./components/Masonry.js":13,"./components/MastheadSlider.js":14,"./lib/Forms.js":19,"./lib/a4jAjaxEvents.js":21,"./polyfills/requestAnimationFrame.js":22,"./site/AddClassOnScroll.js":23,"./site/MobileMenu.js":24,"./site/pages/insights.js":25,"salvattore":8}],16:[function(require,module,exports){
'use strict';

/**
 * List of available easing names available through jQuery and via 'module.exports' (e.g. AnimationEasing.easeInOutCubic):
 * <ul>
 * <li>linear
 * <li>swing
 * <li>easeInQuad
 * <li>easeOutQuad
 * <li>easeInOutQuad
 * <li>easeInCubic
 * <li>easeOutCubic
 * <li>easeInOutCubic
 * <li>easeInQuart
 * <li>easeOutQuart
 * <li>easeInOutQuart
 * <li>easeInQuint
 * <li>easeOutQuint
 * <li>easeInOutQuint
 * <li>easeInExpo
 * <li>easeOutExpo
 * <li>easeInOutExpo
 * <li>easeInSine
 * <li>easeOutSine
 * <li>easeInOutSine
 * <li>easeInCirc
 * <li>easeOutCirc
 * <li>easeInOutCirc
 * <li>easeInElastic
 * <li>easeOutElastic
 * <li>easeInOutElastic
 * <li>easeInBack
 * <li>easeOutBack
 * <li>easeInOutBack
 * <li>easeInBounce
 * <li>easeOutBounce
 * <li>easeInOutBounce
 * </ul>
 * 
 * These are based on jQueryUI. Documentation (with nice graphs): http://api.jqueryui.com/easings/
 */


/*! jQuery UI - v1.11.4 - 2016-03-12
* http://jqueryui.com
* Includes: effect.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */
// Based on easing equations from Robert Penner (http://www.robertpenner.com/easing)

var AnimationEasing = {};
var baseEasings = {};

// Create an object that contains all base easing functions
var baseEasingNames = ['Quad', 'Cubic', 'Quart', 'Quint', 'Expo'];
for (var i in baseEasingNames) {
	addBaseEasingFn(i, baseEasingNames[i]);
}
function addBaseEasingFn(i, name) {
	baseEasings[name] = function(p) {
		return Math.pow(p, i + 2);
	};
}

// Add a few specific ones;
baseEasings.Sine = function(p) {
	return 1 - Math.cos( p * Math.PI / 2 );
};
baseEasings.Circ = function(p) {
	return 1 - Math.sqrt( 1 - p * p );
};
baseEasings.Elastic = function(p) {
	return p === 0 || p === 1 ? p :
		-Math.pow( 2, 8 * (p - 1) ) * Math.sin( ( (p - 1) * 80 - 7.5 ) * Math.PI / 15 );
};
baseEasings.Back = function(p) {
	return p * p * ( 3 * p - 2 );
};
baseEasings.Bounce = function(p) {
	var pow2, bounce = 4;
	while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
	return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
};

// Iterate through the base easing functions and create 'easeIn' 'easeOut' and 'easeInOut' variations
for (var name in baseEasings) {
	if (baseEasings.hasOwnProperty(name)) {
		addVariations(name, baseEasings[name])
	}
}
function addVariations(name, easeFn) {
	addEasingFn('easeIn' + name, easeFn);
	addEasingFn('easeOut' + name, function(p) {
		return 1 - easeFn( 1 - p );
	});
	var inOutFn = addEasingFn('easeInOut' + name, function(p) {
		return p < 0.5 ?
				easeFn( p * 2 ) / 2 :
				1 - easeFn( p * -2 + 2 ) / 2;
	});
}
// TODO Create a cubic bezier variations that provides a lot of flexiblity. E.g: http://cubic-bezier.com/

// Add 'linear' and 'swing'
addEasingFn('linear', function(p) {
	return p;
});
addEasingFn('swing', function(p) {
	return 0.5 - Math.cos( p * Math.PI ) / 2;
});

function addEasingFn(name, fn) {
	AnimationEasing[name] = fn;
	if (window.jQuery) {
		// TODO Only works if jQuery is global. Should add away for another module to pass a reference for setup.
		window.jQuery.easing[name] = fn;
	}
	return fn;
};

// Change default easing in jQuery
if (window.jQuery) {
	window.jQuery.easing.def = 'easeOutQuad';
}

module.exports = AnimationEasing;

},{}],17:[function(require,module,exports){
'use strict';

/**
 * Auto loads next page of results when getting close to bottom of a scrollable area.
 * New results are appended to previous results and pagination is replaced with
 * pagination form the new page.
 * 
 * Here is an example setup. All options are required except as marked below.
 * 
	AutoLoadPages.setup({
		scrollableArea: '.table-wrap',		// Can be a string selector or jQuery object.
		resultsSelector: '.section--residences__results tbody',
		paginationSelector: '.pagination',
		nextSelector: '.next',
		loadWhenDistanceFromBottom: 200								// Optional
	});
 * 
 */

var $ = window.jQuery;
var Debouncer = require('./Debouncer.js');

function AutoLoadPages(opt) {
	opt.nextSelector = opt.nextSelector || '.next';
	opt.loadWhenDistanceFromBottom = opt.loadWhenDistanceFromBottom !== undefined ? opt.loadWhenDistanceFromBottom : 400;
	
	this.opt = opt;
	
	// If ajax happens we resetup to ensure if elements we reference change we get the most recent reference.
	$(document).on('ajaxComplete', this.setup.bind(this));
	
	// Initial setup.
	this.setup();
}
AutoLoadPages.prototype.destroy = function() {
	if (this.loadNextIfNeededDebouncer !== undefined) {
		// Setup to check if next page needs to loaded when window scrolled or window resized
		this.$scrollableArea.off('scroll', this.loadNextIfNeededDebouncer.run);
		$(window).off('load', this.loadNextIfNeededDebouncer.run);
		$(window).off('resize', this.loadNextIfNeededDebouncer.run);
	}
	
}
AutoLoadPages.prototype.setup = function() {
	var opt = this.opt;
	
	// If setup previously then undo setup and redo
	this.destroy();
	
	var $scrollableArea = typeof opt.scrollableArea === 'object' ? opt.scrollableArea : $(opt.scrollableArea);
	this.$scrollableArea = $scrollableArea;
	
	var $results = $(opt.resultsSelector);
	var $pagination = $(opt.paginationSelector);
	$pagination.addClass('isAutoLoadPage--setup');
	
	if (!$pagination || !$results) {
		// Nothing to setup
		return;
	}
	
	var currentlyLoading = false;
	
	var loadNextIfNeededDebouncer = new Debouncer(function(e) {
		var bottomOfResults =
				($results.get(0) === window ? 0 : $results.offset().top)
				+ $results.outerHeight();
		var bottomOfScrollableArea =
				$scrollableArea.scrollTop()
				+ $scrollableArea.outerHeight();
		
		if (bottomOfResults - bottomOfScrollableArea <= opt.loadWhenDistanceFromBottom) {
			// Near bottom of results, load next page.
			
			loadNextPage();
		}
	});
	this.loadNextIfNeededDebouncer = loadNextIfNeededDebouncer;
	
	var loadNextPage = function() {
		if (currentlyLoading || !$pagination) {
			// Already loading or  no next page to load.
			return false;
		}
		
		var $more = $pagination.find(opt.nextSelector);
		if (!$more) {
			return false;
		}
		
		var loadHref = $more.attr('href');
		if (typeof loadHref === 'undefined' || !loadHref.length) {
			return false;
		}
		
		// Stop multiple pages from loading at once
		currentlyLoading = true;

		// Seems new version of jQuery changes: /centpoint-web/insights.html?_=1466191391264&page=3
		//  to /centpoint-web/insights.html&page=3?_=1466191391265
		// 	so we remove the parameter to ensure we don't run into an issue
		loadHref = loadHref.replace(/&?_=[0-9]+/, '');
		loadHref = loadHref.replace(/\?&/, '?');
		
		// Load next page
		$.ajax({
			url: loadHref,
			cache: false
		}).done(function(html) {
			var $html = $(html);
			
			// Append new results
			$html.find(opt.resultsSelector).children().appendTo($results);
			
			// Update pagination
			var newPagination = $html.find(opt.paginationSelector);
			if (newPagination) {
				$pagination.replaceWith(newPagination);
				$pagination.addClass('isAutoLoadPage--setup');
				$pagination = newPagination;
			} else {
				// No more results
				$pagination.remove();
				$pagination = null;
			}
			
			// Set back so another page can load.
			currentlyLoading = false;
			
			// Check if even though we just loaded a page we need to load another one to fill the area.
			loadNextIfNeededDebouncer.runNow();
			
			// Tigger event
			$results.trigger('autoLoadedPages', {url: loadHref});
		});
	}
	
	// Setup to check if next page needs to loaded when window scrolled or window resized
	$scrollableArea.on('scroll', this.loadNextIfNeededDebouncer.run);
	$(window).on('load', this.loadNextIfNeededDebouncer.run);
	$(window).on('resize', this.loadNextIfNeededDebouncer.run);
};

module.exports = AutoLoadPages;


},{"./Debouncer.js":18}],18:[function(require,module,exports){
'use strict';

/**
 * @class
 * Example use:
 * 	var resizeDebouncer = new Debouncer(callbackFn);
 *  window.addEventListener('resize', resizeDebouncer.run, false);
 *  
 * Or, if using JQuery (but you can also 
 * 	var resizeDebouncer = new Debouncer(callbackFn);
 *  $(window).bind('resize', resizeDebouncer.run);
 * 
 * Or, all on one line:
 *  $(window).bind('resize', (new Debouncer(callbackFn)).run);
 */
function Debouncer(callback) {
	var self = this;
	
	this._callback = callback;
	this._requestAnimationFrame = null;
	
	/**
	 * This will run the callback provided during construction of a Debouncer.
	 * Any passed arguments to run(...) will be passed to the callback.
	 * Calls are debounced using requsetAnimationFrame.
	 * @public
	 */
	this.run = function() {
		_run(self, this, arguments);
	}
}

/**
 * @private
 */
function _run(debouncer, thisArg, args) {
	debouncer.cancel();
	debouncer._requestAnimationFrame = requestAnimationFrame(function() {
		debouncer._callback.apply(thisArg, args);
	});
}

/**
 * Run the callback method immediately without debouncing.
 * Any active debouncing is canceled first.
 * @public
 */
Debouncer.prototype.runNow = function() {
	this.cancel();
	this._callback.apply(this, arguments);
}
/**
 * Cancel a call to 'run'.
 * @public
 */
Debouncer.prototype.cancel = function() {
	cancelAnimationFrame(this._requestAnimationFrame);
}

module.exports = Debouncer;

},{}],19:[function(require,module,exports){
'use strict';

var $ = window.jQuery;

var waitingClass = 'isWaiting';
var waitClass = 'wait';
var focusClass = 'isFocus';
var hoverClass = 'isHover';
var formButtons = 'input[type=submit], input[type=button], button';
var filledClass = 'isFilled';

var isAJAXSetup = false;
var $body = $(document.body);
var _forms = null;


/**
 * Use:
 * var Forms = require('./lib/Forms.js');
 * Forms.init();
 * 
 * You can then use the public methods to do a few things. For example use Forms.getForms() to get a reference to call forms.
 */
var Forms = {};
 
/**
 * Get forms
 */
Forms.getForms = function() {
	if (_forms === null) {
		_forms = $('form');
	}
	return _forms;
}

/**
 * Reset cached form references.
 * @private
 */
function resetForms() {
	_forms = null;
}


/**
 * Pause forms from submitting
 */
Forms.pauseForms = function() {
	var forms = Forms.getForms();
	forms.addClass(waitingClass);
	forms.find(formButtons)
		.css({'visibility': 'hidden'})
		.after('<span class='+waitClass+'><i></i></span>')
		.parent().addClass(waitingClass);
}

/**
 * Allow form submission again
 */
Forms.releaseForms = function() {
	var forms = Forms.getForms();
	forms
		.removeClass(waitingClass)
		.find(formButtons)
		.css({'visibility': ''})
		.parent().removeClass(waitingClass)
		.find('.'+waitingClass).remove();
}

/**
 * Scroll page to messages if there are any and the user is not already scrolled down
 */
Forms.scrollToMessages = function() {
	if ($(document).scrollTop() === 0) {
		var $msgs = $('.messages');
		if ($msgs.length) {
			$('html, body').stop(true);
			
			var top = $msgs.first().offset().top - 50;
			var left = $msgs.first().offset().left - 50;
			
			var sectionScroller = $(document.body).data('sectionScroller');
			if (sectionScroller !== undefined) {
				sectionScroller.animateTo(left, top);
			} else {
				$('body').animate({'scrollTop' : top}, 1000, 'easeOutQuart');
			}
		}
	}
}

/**
 * Initialize forms. Can be called multiple times to reset forms.
 */
Forms.init = function() {
	var forms = Forms.getForms();
	
	// Fixes ajax auto-populate issue (e.g. "purpose" field that shows more fields based on value)
	forms.find('[onchange]').each(function(){
		var $this = $(this);
		if ($this.val().length) { // TODO Expand this code to work well with more field types. Think about checkboxes and radios.
			$this.trigger('change');
		}
	});
	
	// Setup AJAX Forms
	if (!isAJAXSetup) {
		// Setup form listeners
		$(document.body).on('ajaxSend', function() { resetForms(); });
		$(document.body).on('ajaxComplete', function() { 
			Forms.releaseForms(); 
		});
		
		isAJAXSetup = true;
	}

	var styleAndScroll = function() {
		//Prevent double submit of forms
		var formSubmitEvents = 'ajaxSend submit';
		$body.on(formSubmitEvents, forms, formEventListener);
		
		// Add a class to fieldArea when user is hovering over or has focus on a form field. We use this to show any field specific messages.
		var formFieldEvents = 'mouseenter mouseleave focus blur';
		var formFieldSelector = 'input, select, textarea';
		$body.on(formFieldEvents, formFieldSelector, formFieldEventListener);
	
		// Add a class to fieldArea when not empty
		var formValueEvents = 'change keyup manualTrigger.change';
		var formValueSelector = 'input, select, textarea';
		$body.on(formValueEvents, formValueSelector, formValueListener);
		// Trigger event to cause fields to be setup. We use a custom event instead of 'change' because if we use 'change' the a4j:support
		//   on some fields causes ajax, which then causes the function we are in to be called again -- which means infinite loop.
		forms.find(formValueSelector).trigger('manualTrigger.change');
		
		// Scroll to Messages
		Forms.scrollToMessages();
	}
	
	$(document.body).on('ajaxComplete', styleAndScroll);
	
	styleAndScroll();
} 

/**
 * @private
 * @param event
 */
function formEventListener(event){
	if ($(this).hasClass(waitingClass)) {
		event.preventDefault();
		return false;
	} else {
		Forms.pauseForms();
	}
}

/**
 * @private
 * @param event
 */
function formFieldEventListener(event) {
	var $input = $(this);
	var $area = $input.closest('.fieldArea');
	if (!$area.length) { return };
	
	var eventType = event.type;
	
	if (eventType === 'mouseenter') {
		$area.addClass(hoverClass);
	} else if (
		(eventType === 'mouseleave' && !$area.hasClass(focusClass)) ||
		(eventType === 'blur') ||
		(eventType === 'focusout')
	) {
		$area.removeClass(hoverClass);
		$area.removeClass(focusClass);
	} else if (eventType.indexOf('focus') > -1) {
		if (($input.get(0).type === 'select-one') && $area.hasClass(hoverClass)) {
			// Remove if user clicked to open a select one field. Otherwise the arrow is partially visible.
			$area.removeClass(focusClass);
		} else {
			$area.addClass(focusClass);
		}
	}
}

/**
 * @private
 */
function formValueListener() {
	var $input = $(this);
	var $area = $input.closest('.fieldArea');
	if (!$area.length) {
		return;
	}
	
	var addClass = $input.val() !== '';
	
	$area.toggleClass(filledClass, addClass);
}



module.exports = Forms;


},{}],20:[function(require,module,exports){
'use strict';

var $ = window.jQuery;

var win = $(window);
var body = $(document.body);

var state = {
	prev : null,
	curr : null
};
var breakpoint = {
	prev : null,
	curr : null
};

var _tracker;
function getTracker() {
	if (_tracker === undefined) {
		var elem = document.createElement('div');
		elem.id = 'ViewportTracker';
		_tracker = $(elem);
		body.append(_tracker);
	}
	return _tracker;
}

function getState() {
	return $('header .menuTriggers').css('display') == 'block' ? 'mobile' : 'desktop';
}
function getBreakpoint() {
	return getTracker().width();
}

function onResize() {
	breakpoint.prev = breakpoint.curr;
	breakpoint.curr = getBreakpoint();
	if (breakpoint.prev != breakpoint.curr){
		win.triggerHandler('ViewportTracker:breakpoint', [breakpoint.curr]);
	}
	
	state.prev = state.curr;
	state.curr = getState();
	if (state.prev != state.curr){
		win.triggerHandler('ViewportTracker:state', [state.curr]);
	}
}
win.on('resize', onResize);
win.on('load', onResize);

var ViewportTracker = {
	getState: getState,
	getBreakpoint: getBreakpoint
};

module.exports = ViewportTracker;

},{}],21:[function(require,module,exports){
'use strict';

/**
 * Sends JQuery events when RichFaces / A4J does an ajax request
 */
if (typeof A4J !== 'undefined' && A4J.AJAX) {
	var listeners = {
		queueonsubmit: function(request) {
			if (request.domEvt.target != null) {
				$(request.domEvt.target).parents('form').trigger('ajaxSend');
			}
			//return false;
		},
		queueoncomplete: function(request, event, data) {
			if (request.domEvt.target != null) {
				$(request.domEvt.target).parents('form').trigger('ajaxSuccess');
				$(request.domEvt.target).parents('form').trigger('ajaxComplete');
			}
		},
		queueonerror: function(request, status, message) {
			if (request.domEvt.target != null) {
				$(request.domEvt.target).parents('form').trigger('ajaxError');
				$(request.domEvt.target).parents('form').trigger('ajaxComplete');
			}
		}
	};
	A4J.AJAX.EventQueue.addQueue(new A4J.AJAX.EventQueue('org.richfaces.queue.global', null, listeners));
}
},{}],22:[function(require,module,exports){
'use strict';

/**
 * requestAnimationFrame polyfill
 */
var lastTime = 0;
var vendors = [ 'ms', 'moz', 'webkit', 'o' ];
for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
}

if (!window.requestAnimationFrame) {
	window.requestAnimationFrame = function(callback, element) {
		var currTime = new Date().getTime();
		var timeToCall = Math.max(0, 16 - (currTime - lastTime));
		var id = window.setTimeout(function() {
			callback(currTime + timeToCall);
		}, timeToCall);
		lastTime = currTime + timeToCall;
		return id;
	};
}

if (!window.cancelAnimationFrame) {
	window.cancelAnimationFrame = function(id) {
		clearTimeout(id);
	};
}


},{}],23:[function(require,module,exports){
'use strict';

var $ = window.jQuery;
var body = $(document.body);
var win = $(window);
var distance = 40;

function init() {

	var css = "scrolled";
	var eventHandler = function () {
		if ( win.scrollTop() < distance ) {
			body.removeClass( css );
		} else {
			body.addClass( css );
		}
	}
	eventHandler();
	win.on('scroll.addClass', eventHandler);

}

var ScrolledClass = {
	init: init
};

module.exports = ScrolledClass;
},{}],24:[function(require,module,exports){
'use strict';

var $ = window.jQuery;
var ViewportTracker = require('../lib/ViewportTracker.js');
var AnimationEasing = require('../lib/AnimationEasing.js');

function init() {
	var config = {
		menu : '#menu',
		menuActive : false,
		menuCSS : 'hasMenuOpen',
		setupCSS : 'hasMenuSetup',
		subOpenedCSS : 'isOpen',
		subTarget : '.child-wrap',
		subTrigger : '.hasChild > a',
		triggers : '#menuTrigger--open, #menuTrigger--close, #menuOverlay',
		triggerEvent : 'click'
	};
	var $menu = $(config.menu);
	var $stateElem = $menu;
	var $subtarget = $menu.find(config.subTarget);
	
	function toggleMenu(event) {
		event.preventDefault();
		$stateElem.toggleClass(config.menuCSS);
	}
	function toggleSub(event) {
		event.preventDefault();
		var $target = $((event.target.tagName == 'SPAN') ? event.target.parentNode : event.target);
		$target.next().slideToggle(400, AnimationEasing.easeOutExpo);
		$target.parent('li').toggleClass(config.subOpenedCSS);
	}
	function begSub() {
		$stateElem.toggleClass(config.setupCSS);
		$subtarget.filter('.active').parents('li').addClass(config.subOpenedCSS)
		$subtarget.stop().not('.active').slideUp();
	}
	function endSub() {
		$stateElem.toggleClass(config.setupCSS);
		$subtarget.parents('li').removeClass(config.subOpenedCSS)
		$subtarget.stop().slideDown().attr('style', '');
	}
	function attachEventsWin() {
		if (config.menuActive === true) {
			return;
		}
		$(config.triggers).on(config.triggerEvent, toggleMenu);
		begSub();
		$menu.on('click.mobileMenu', config.subTrigger, toggleSub);
	}
	function detachEventsWin() {
		if (config.menuActive === false) {
			return;
		}
		$(config.triggers).off(config.triggerEvent, toggleMenu);
		endSub();
		$menu.off('click.mobileMenu');
	}
	function onViewportState() {
		var state = ViewportTracker.getState();
		$stateElem.removeClass(config.menuCSS);
		if (state == 'mobile') {
			attachEventsWin();
			config.menuActive = true;
		} else {
			detachEventsWin();
			config.menuActive = false;
		}
	}
	onViewportState();
	
	$(window).on('ViewportTracker:state', onViewportState);
}

var MobileMenu = {
	init: init
};


module.exports = MobileMenu;

},{"../lib/AnimationEasing.js":16,"../lib/ViewportTracker.js":20}],25:[function(require,module,exports){
'use strict';

var $ = window.jQuery;

var AutoLoadPages = require('../../lib/AutoLoadPages.js');

module.exports = {
	load: function() {
		if ($('.pagination').length === 0) {
			return;
		}
		
		// Setup auto load of next page of units as the user scrolls the results
		var autoLoadPages = new AutoLoadPages({
			scrollableArea: $(window),
			resultsSelector: '#queryResults',
			paginationSelector: '.pagination',
			nextSelector: '.next',
			loadWhenDistanceFromBottom: 200
		});
	},
	unload: function() {
	}
};
},{"../../lib/AutoLoadPages.js":17}]},{},[15])

